type CustomerLogo = {
  name: string
  image: string
  size?: 'sm' | 'md'
  weight?: number
}

export const CustomerLogos: CustomerLogo[] = [
  { name: 'condéNast', image: `conde-nast.svg` },
  { name: 'buzzfeed', image: 'buzzfeed.svg' },
  { name: 'checkr', image: 'checkr.svg' },
  { name: 'perplexity', image: 'perplexity-color.svg', weight: 1.2 },
  { name: 'mercury', image: 'mercury.svg', weight: 1.25 },
  { name: 'guitarCenter', image: 'guitar-center-color.svg', weight: 1.4 },
  { name: 'dbtLabs', image: 'dbt-labs.svg' },
  { name: 'tripAdvisor', image: 'tripadvisor.svg' },
  { name: 'bambooHR', image: 'bamboo-hr.svg' },
  { name: 'synthesia', image: 'synthesia.svg' },
  { name: 'brevo', image: 'brevo.svg' },
  { name: 'heidi', image: 'heidi.svg' },
  { name: 'cribl', image: 'cribl.svg' },
  { name: 'caraway', image: 'caraway.svg' },
  { name: 'swbc', image: 'swbc.svg', weight: 1.3 },
  { name: 'hightouch', image: 'hightouch.svg' },
  { name: 'ilia', image: 'ilia.svg' },
  { name: 'ritual', image: 'ritual.svg' },
  { name: 'incidentIO', image: 'incidentio.svg' },
  { name: 'zip', image: 'zip.svg' },
  { name: 'gameLounge', image: 'gamelounge.svg' },
  { name: 'ogury', image: 'ogury.svg' },
  { name: 'ordermentum', image: 'ordermentum.svg' },
]

export const CustomerLogos2: CustomerLogo[] = [
  { name: 'dbtLabs', image: 'dbt-labs.svg' },
  { name: 'snowflake', image: 'snowflake.svg' },
  { name: 'AWS', image: 'aws.svg' },
  { name: 'coalesce', image: 'coalesce.svg' },
  { name: 'databricks', image: 'databricks.svg' },
  { name: 'matia', image: 'matia.svg' },
  { name: 'motherDuck', image: 'motherduck.svg' },
  { name: 'secoda', image: 'secoda.svg' },
  { name: 'clickhouse', image: 'clickhouse.svg' },
  { name: 'synq', image: 'synq.svg' },
  { name: 'tobiko', image: 'tobiko.svg' },
  { name: 'fivetran', image: 'fivetran.svg' },
  { name: 'atlan', image: 'atlan.svg' },
  { name: 'estuary', image: 'estuary.png' },
  { name: 'validio', image: 'validio.svg' },
]

export const CustomerLogos3: CustomerLogo[] = [
  { name: 'astroData', image: 'astro-data.png' },
  { name: 'phData', image: 'ph-data.svg' },
  { name: 'shearwater', image: 'shearwater.svg' },
  { name: 'hawkfry', image: 'hawkfry.png' },
  { name: 'infiniteLambda', image: 'infinite-lambda.svg' },
  { name: 'brooklynData', image: 'brooklyn-data.svg' },
  { name: 'archetype', image: 'archetype.svg' },
  { name: 'tropos', image: 'tropos.svg' },
  { name: 'spaulding-ridge', image: 'spaulding-ridge.png' },
  { name: 'tasman', image: 'tasman.svg' },
  { name: 'interworks', image: 'interworks.svg' },
  { name: 'analytics8', image: 'analytics8.svg' },
  { name: 'billigence', image: 'billigence.png' },
  { name: 'altis', image: 'altis.svg' },
  { name: 'cynozure', image: 'cynozure.svg' },
  { name: 'bigTimeData', image: 'big-time-data.svg' },
  { name: 'spicyData', image: 'spicy-data.png' },
  { name: 'corail', image: 'corail.png' },
  { name: 'ezData', image: 'ez-data.svg' },
]

const logoPath = '/images/customer-logos/'

export const customerLogos = {
  activeProspect: `${logoPath}/activeprospect.svg`,
  altis: `${logoPath}/altis.svg`,
  analytics8: `${logoPath}/analytics8.svg`,
  ascend: `${logoPath}/ascend.svg`,
  astroData: `${logoPath}/astro-data.webp`,
  aura: `${logoPath}/aura.svg`,
  aviatrix: `${logoPath}/aviatrix.svg`,
  bambooHR: `${logoPath}/bamboo-hr.svg`,
  bigTimeData: `${logoPath}/bigtime-data.svg`,
  billigence: `${logoPath}/billigence.webp`,
  bluecharm: `${logoPath}/bluecharm.webp`,
  brevo: `${logoPath}/brevo.svg`,
  brooklyndata: `${logoPath}/brooklyn-data.svg`,
  buzzfeed: `${logoPath}/buzzfeed.webp`,
  caraway: `${logoPath}/caraway.svg`,
  census: `${logoPath}/census.webp`,
  clickhouse: `${logoPath}/clickhouse.svg`,
  checkr: `${logoPath}/checkr.svg`,
  cribl: `${logoPath}/cribl.svg`,
  cynozure: `${logoPath}/cynozure.svg`,
  dagster: `${logoPath}/dagster.webp`,
  databricks: `${logoPath}/databricks.svg`,
  digitalTrends: `${logoPath}/digitaltrends.svg`,
  driveMyWay: `${logoPath}/drive-my-way.webp`,
  ebh: `${logoPath}/ebh.webp`,
  feeld: `${logoPath}/feeld.svg`,
  foxglove: `${logoPath}/foxglove.webp`,
  fundrise: `${logoPath}/fundrise.svg`,
  gameLounge: `${logoPath}/gamelounge.svg`,
  glass: `${logoPath}/glass.webp`,
  guitarCenter: `${logoPath}/guitar-center-color.svg`,
  hawkfry: `${logoPath}/hawkfry.webp`,
  heidi: `${logoPath}/heidi.svg`,
  incidentio: `${logoPath}/incidentio.svg`,
  infiniteLambda: `${logoPath}/infinite-lambda.svg`,
  interworks: `${logoPath}/interworks.svg`,
  maze: `${logoPath}/maze.webp`,
  mercury: `${logoPath}/mercury.svg`,
  middleware: `${logoPath}/middleware.svg`,
  mileiq: `${logoPath}/mileiq.webp`,
  ogury: `${logoPath}/ogury.svg`,
  ordermentum: `${logoPath}/ordermentum.svg`,
  perplexity: `${logoPath}/perplexity-color.svg`,
  phData: `${logoPath}/ph-data.svg`,
  prefect: `${logoPath}/prefect.webp`,
  primaryBid: `${logoPath}/primarybid.svg`,
  photoroom: `${logoPath}/photoroom.svg`,
  meAndU: `${logoPath}/meandu.svg`,
  rampNetwork: `${logoPath}/rampnetwork.svg`,
  roseRocket: `${logoPath}/rose-rocket.svg`,
  roseRocket2: `${logoPath}/rose-rocket-color.svg`,
  secoda: `${logoPath}/secoda.svg`,
  shearwater: `${logoPath}/shearwater.svg`,
  smartAccess: `${logoPath}/smart-access.webp`,
  smugmug: `${logoPath}/smugmug.webp`,
  snowflake: `${logoPath}/snowflake.svg`,
  spauldingRidge: `${logoPath}/spaulding-ridge.webp`,
  standardMetrics: `${logoPath}/standard-metrics.svg`,
  storyworth: `${logoPath}/storyworth.webp`,
  swbc: `${logoPath}/swbc.svg`,
  superorder: `${logoPath}/superorder.webp`,
  synthesia: `${logoPath}/synthesia.svg`,
  tapcheck: `${logoPath}/tapcheck.webp`,
  tasman: `${logoPath}/tasman.svg`,
  theRounds: `${logoPath}/the-rounds.svg`,
  torotms: `${logoPath}/torotms.webp`,
  tripAdvisor: `${logoPath}/tripadvisor.svg`,
  trint: `${logoPath}/trint.svg`,
  tropos: `${logoPath}/tropos.svg`,
  uscreen: `${logoPath}/uscreen.svg`,
  validio: `${logoPath}/validio.svg`,
  workRamp: `${logoPath}/workramp.svg`,
  zapnito: `${logoPath}/zapnito.svg`,
}
